import React, {useState} from 'react';
import './style.scss';
import ScheduleIcon from '@material-ui/icons/ScheduleRounded';
import ScheduleNotificationDialog from "./ScheduleNotificationDialog/ScheduleNotificationDialog";


export default function OrderScheduleNotification(props) {
    const [isSchedulerDialogOpen, setIsSchedulerDialogOpen] = useState(false);

    function handleClick(e) {
        e.stopPropagation();

        if (!isTouchDevice())
            handleClickSchedulerContent();
    }

    function handleTouchEnd(e) {
        e.stopPropagation();

        handleClickSchedulerContent();
    }

    function handleClickSchedulerContent() {
        openSchedulerDialog();
    }

    function openSchedulerDialog() {
        setIsSchedulerDialogOpen(true);
    }

    function handleCloseSchedulerDialog() {
        setIsSchedulerDialogOpen(false);
    }

    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement;
    }

    function handleChooseSchedulerMinutes(minutes) {
        props.scheduleNotificationOrder(props.order.bid, props.order.id, props.order.placeOfDeparture, minutes);

        setIsSchedulerDialogOpen(false);
    }

    return (
        <>
            <div className="order-schedule-notification">
                <span className="order-schedule-notification-icon-container"
                      onClick={handleClick}
                      onTouchEnd={handleTouchEnd}
                      aria-label="Delete">
                    <div className="order-schedule-notification-icon">
                        <ScheduleIcon fontSize="small"/>
                    </div>
                </span>
            </div>
            <ScheduleNotificationDialog isOpen={isSchedulerDialogOpen}
                                        onCloseDialog={handleCloseSchedulerDialog}
                                        onChooseMinutes={handleChooseSchedulerMinutes}/>
        </>
    );
}
